export const basicDetailsStyle = theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    upload: {
        display: 'none'
    },
})